import { Button } from "@chakra-ui/react";
import React from "react";
import { FaGoogle } from "react-icons/fa";

export default function GoogleButton({ size = "sm", width = "full" }) {
  const API_BASE = process.env.REACT_APP_API_URL || "https://localhost:7211";

  const handleGoogleLogin = () => {
    // Redirect to backend Google OAuth endpoint
    window.location.href = `${API_BASE}/api/auth/google`;
  };

  return (
    <Button
      leftIcon={<FaGoogle />}
      bg="gray.600"
      color="white"
      size={size}
      w={width}
      onClick={handleGoogleLogin}
      _hover={{
        bg: "gray.500",
      }}
      _active={{
        bg: "gray.700",
      }}
    >
      Google
    </Button>
  );
}
